import axios from 'axios';

export default {
    checkIntegration() {
        return axios.get(window.API_BASE + '/sage/check-integration');
    },

    getContacts(params = {}) {
        return axios.get(window.API_BASE + '/sage/contacts', { params });
    },

    connect() {
        return axios.post(window.API_BASE + '/sage/authorization-url');
    },

    disconnect() {
        return axios.post(window.API_BASE + '/sage/deactivate');
    }
}
